import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { ReactComponent as CloseIcon } from '@blink/assets/src/icons/close.svg';
import { ReactComponent as MailIcon } from '@blink/assets/src/icons/mail.svg';

import { useHideModal, useModal } from '@/features/Modals';
import { Button, ButtonVariant } from '@/shared/ui';

interface FormValues {
    invites: string[];
}

export const CancelInvitesModal: FC = () => {
    const { handleCloseModal } = useHideModal();
    const { modalProps } = useModal();
    const { invites = [] }: { invites?: string[] } = modalProps || {};

    const { setValue } = useForm<FormValues>({
        mode: 'onChange',
        defaultValues: {
            invites: invites,
        },
    });

    const handleCancel = () => {
        handleCloseModal();
    };

    const handleRemoveEmail = (email: string) => {
        setValue(
            'invites',
            invites.filter((e: string) => e !== email),
        );
    };

    const handleCancelInvites = () => {
        console.log('Invites cancelled:', invites);
    };

    return (
        <div className='flex flex-col min-w-[500px] mt-[54px]'>
            {invites.length > 0 && (
                <div className='flex flex-col items-start p-5 mt-5 gap-3 flex-[1_0_0] self-stretch rounded-[var(--radius-overall)] border border-opaque bg-background-primary'>
                    <div className="overflow-hidden text-content-primary [font-feature-settings:'calt_off'] text-ellipsis text-[14px] font-medium leading-[20px] tracking-[-0.42px] whitespace-nowrap">
                        Cancel invitations ({invites.length})
                    </div>
                    {invites.map((email) => (
                        <div
                            key={email}
                            className='flex justify-between items-center self-stretch rounded-[var(--radius-overall)] bg-background-secondary px-[6px] py-3 pl-5'
                        >
                            <div className='flex items-center gap-4 [&>span]:text-content-secondary'>
                                <MailIcon />
                                <div className='flex items-center gap-4 [&>span]:text-content-secondary'>
                                    {email} <span>(Member)</span>
                                </div>
                            </div>
                            <Button
                                variant={ButtonVariant.Tertiary}
                                className='flex items-center justify-center px-4 py-[10px] gap-2 text-md bg-background-secondary'
                                onClick={() => handleRemoveEmail(email)}
                            >
                                <CloseIcon />
                            </Button>
                        </div>
                    ))}
                </div>
            )}

            <div className='flex justify-end self-stretch gap-3 mt-7'>
                <Button
                    variant={ButtonVariant.Secondary}
                    className='flex items-center justify-center px-4 py-[10px] text-md'
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
                <Button
                    variant={ButtonVariant.Primary}
                    className='flex items-center justify-center px-4 py-[10px] text-md bg--background-negative !important'
                    disabled={invites.length === 0}
                    onClick={handleCancelInvites}
                >
                    Cancel Invites
                </Button>
            </div>
        </div>
    );
};
